<template lang="pug">
modal#delete-team-modal(
  :buttonColor='buttonColor'
  :close-button-label='$t("modal.deleteTeam.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.deleteTeam.processButtonLabel")'
  :title='$t("modal.deleteTeam.title")'
  @closed='$emit("closed")'
  @process='deleteTeam'
  processButtonClass='btn-danger'
  ref='modal'
  size='md'
)
  p(v-html='$t("modal.deleteTeam.message")')
  p(v-html='$t("modal.deleteTeam.messageSharedEnvelopes")')
  p(v-html='$t("modal.deleteTeam.messageRestore")')
  p(v-html='$t("modal.deleteTeam.messageSure")')
  img.d-flex.m-auto.mt-5.text-center(
    src='/img/ilustrations/developer-delete-warning.svg'
  )
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import Icon from '@/ui/atoms/Icon.vue';
import TeamsService from '@/modules/account/services/http/TeamsService';
import alert from '@/modules/account/common/alert';

export default {
  props: {
    team: Object,
  },
  components: {
    Modal,
    Icon,
    ImageLoader,
  },
  data() {
    return {
      loading: true,
      buttonColor: true,
      errors: {},
    };
  },
  methods: {
    deleteTeam() {
      this.$loading(true);
      TeamsService.remove(this.team.id)
        .then((res) => {
          if (res.status === 204) {
            alert.fireAlert(this.$t('modal.deleteTeam.deleted'), {
              classes: 'alert-success',
              styles:
                'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
              icon: 'circle-check',
            });
            this.$refs.modal.close();
            this.$emit('refresh');
          }
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
